import { z } from "zod";

import { permissions } from "~/admins/constants/auth";

export const loginAdminFormSchema = z.object({
  email: z
    .email({ error: "Please enter a valid email address." })
    .min(1, { error: "Email is required" }),
  password: z.string().min(1, { error: "Password is required" }),
});

export const loginAdminRequestSchema = loginAdminFormSchema;

export const passwordSchema = z
  .object({
    password: z.string(),
    passwordConfirmation: z.string(),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    path: ["passwordConfirmation"],
    error:
      "Passwords don't match. Please make sure to enter the same password in both fields.",
  })
  .refine(
    (data) => {
      if (data.password !== data.passwordConfirmation) return true;
      const passwordRegex =
        // eslint-disable-next-line  no-useless-escape
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`!@#$%^&*()_\-+=\[\]{};':"\\|,.<>\/?~ ])[A-Za-z\d`!@#$%^&*()_\-+=\[\]{};':"\\|,.<>\/?~ ]{8,}$/;
      const valid = passwordRegex.test(data.password);
      return valid;
    },
    {
      path: ["password"],
      error: "Passwords don't meet the requirements.",
    },
  );

export const emailSchema = z.object({
  email: z
    .email({ error: "Please enter a valid email address." })
    .min(1, "Email is required"),
});

export const permissionCodesSchema = z.enum(permissions);
